import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SessionsDetailModalSectionTitle from './SessionsDetailModalSectionTitle';
import SessionsParticipantList from '../SessionsParticipantList';
import SessionsParticipantListItem from '../SessionsParticipantListItem';
import DropDown from '../../DropDown/DropDown';
import Button from '../../Button';

const SessionsDetailModalModerator = ({
  onSubmit,
  isEditable,
  disabled,
  moderator,
  moderators,
}) => {
  const [composing, setComposing] = useState(false);
  const [newModeratorId, setNewModeratorId] = useState(null);
  const { t } = useTranslation('components');

  const handleClickEdit = () => setComposing(!composing);

  const handleSubmit = event => {
    if (!newModeratorId) {
      setComposing(false);
      return;
    }

    onSubmit({ newModeratorId }, event);
  };

  const handleModeratorChange = event => {
    const moderatorId = event.target.value;
    if (moderatorId === moderator.userId) {
      setNewModeratorId(null);
      return;
    }

    setNewModeratorId(moderatorId);
  };

  return (
    <section className="mb-6" data-component="SessionsDetailModalModerator">
      <SessionsDetailModalSectionTitle
        onEdit={handleClickEdit}
        isEditable={isEditable && moderators && moderators.options && moderators.options.length > 1}
      >
        {t('Sessions.SessionsDetailModal.chooseModerator')}
      </SessionsDetailModalSectionTitle>
      {composing ? (
        <section className="mb-6">
          <div className="bg-slate-100 p-2 lg:p-4 rounded mb-6">
            <DropDown
              options={moderators.options}
              optionLabels={moderators.labels}
              disabled={disabled}
              onChange={handleModeratorChange}
              initialValue={moderator.userId}
            />
          </div>
          <div className="flex w-full">
            <div className="flex-grow" />
            <Button kind="secondary:ghost" className="text-sm" onClick={handleClickEdit}>
              {t('Sessions.SessionsInvitationForm.close')}
            </Button>
            <Button className="text-sm ml-4" isDisabled={disabled} onClick={handleSubmit}>
              {t('Sessions.SessionsInvitationForm.submit.update')}
            </Button>
          </div>
        </section>
      ) : (
        <>
          {moderator && (
            <SessionsParticipantList className="mb-2">
              <SessionsParticipantListItem
                key={moderator.participantId || moderator.reference}
                reference={moderator.reference}
                readOnly
              >
                {moderator.fullNameWithTitle || `${moderator.lastName}, ${moderator.firstName}`}
              </SessionsParticipantListItem>
            </SessionsParticipantList>
          )}
        </>
      )}
    </section>
  );
};

SessionsDetailModalModerator.propTypes = {
  onSubmit: PropTypes.func,
  isEditable: PropTypes.bool,
  disabled: PropTypes.bool,
  moderators: PropTypes.shape({
    options: PropTypes.arrayOf(PropTypes.string),
    labels: PropTypes.arrayOf(PropTypes.string),
  }),
  moderator: PropTypes.shape({
    reference: PropTypes.string,
    participantId: PropTypes.string,
    fullNameWithTitle: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    avatar: PropTypes.string,
    initials: PropTypes.string,
    userId: PropTypes.string,
    roles: PropTypes.arrayOf(PropTypes.oneOf(['moderator'])),
  }),
};

SessionsDetailModalModerator.defaultProps = {
  onSubmit: () => {},
  moderators: { options: [], labels: [] },
};

export default SessionsDetailModalModerator;
